import React from "react";
import { Colors } from "../../config/Constants";
import {
  AmdIcon,
  AquaIcon,
  CustomerIcon,
  DashboardIcon,
  DisputeIcon,
  EventsIcon,
  LusailYachtClubIcon,
  LwwIcon,
  MerchantIcon,
  PhysicalCardIcon,
  PrivilegeIcon,
  PushnotificationIcon,
  ReportIcon,
  SettingsIcon,
  TopUpTransactionIcon,
} from "../Icons/SidebarIcons";

interface Props {
  isActivePath: boolean;
  path: string;
}

const Icon = ({ path, isActivePath }: Props) => {
  const getIcon = (path: string, isActivePath: boolean) => {
    switch (path) {
      case "dashboard":
        return (
          <DashboardIcon fill={isActivePath ? Colors.red : Colors.white} />
        );
      case "customer":
        return <CustomerIcon fill={isActivePath ? Colors.red : Colors.white} />;
      case "merchant":
        return <MerchantIcon fill={isActivePath ? Colors.red : Colors.white} />;
      case "settings":
        return <SettingsIcon fill={isActivePath ? Colors.red : Colors.white} />;
      case "report":
        return <ReportIcon fill={isActivePath ? Colors.red : Colors.white} />;
      case "push-notification":
        return (
          <PushnotificationIcon
            fill={isActivePath ? Colors.red : Colors.white}
          />
        );
      case "topup-transactions":
        return (
          <TopUpTransactionIcon
            fill={isActivePath ? Colors.red : Colors.white}
          />
        );
      case "physical-card":
        return (
          <PhysicalCardIcon fill={isActivePath ? Colors.red : Colors.white} />
        );
      case "dispute":
        return <DisputeIcon fill={isActivePath ? Colors.red : Colors.white} />;
      case "events":
        return <EventsIcon fill={isActivePath ? Colors.red : Colors.white} />;
      case "manage-outlet":
        return <MerchantIcon fill={isActivePath ? Colors.red : Colors.white} />;
      case "amd-membership":
        return <AmdIcon fill={isActivePath ? Colors.red : Colors.white} />;
      // case "lusail-winter-wonderland":
      //   return <LwwIcon fill={isActivePath ? Colors.red : Colors.white} />;
        case "manage-parks":
          return <LwwIcon fill={isActivePath ? Colors.red : Colors.white} />;
      case "yacht-club":
        return <LusailYachtClubIcon fill={isActivePath ? Colors.red : Colors.white} />;
        case "aqua":
          return <AquaIcon fill={isActivePath ? Colors.red : Colors.white} />;
          case "privilege-account":
            return <PrivilegeIcon fill={isActivePath ? Colors.red : Colors.white} />;
      default:
        return (
          <DashboardIcon fill={isActivePath ? Colors.red : Colors.white} />
        );
    }
  };
  return <>{getIcon(path, isActivePath)}</>;
};

export default Icon;
